import { useState, useRef, useEffect } from "react"
import { Button, Modal, Form, Row, Image, Col } from "react-bootstrap";

export const Company = (props) => {

    const [valid, setValid] = useState(false);
    const [logoTooLarge, setLogoTooLarge] = useState(false);

    const [companyName, setCompanyName] = useState(props.company?.name || '');
    const onCompanyNameChange = (value) => {
        setCompanyName(value);
    }

    const [companyDomain, setCompanyDomain] = useState(props.company?.domain || '');
    const onCompanyDomainChange = (value) => {
        setCompanyDomain(value)
    };

    const filePickerRef = useRef();
    const [companyLogo, setCompanyLogo] = useState(props.company?.logo || '');
    function readFileAsync(file) {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = () => { resolve(reader.result); };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        })
    }
    async function loadLogo(file) {
        let newLogo = await readFileAsync(file)
        setCompanyLogo(newLogo)
    }
    const onCompanyLogoChange = () => {
        const files = filePickerRef.current.files;
        if (files && files.length > 0 && files[0]) {
            if (files[0].size > 500000) {
                console.log(`File too large ${files[0].size}`)
                setLogoTooLarge(true)
                setCompanyLogo(null)
            }
            else {
                setLogoTooLarge(false)
                loadLogo(files[0]);
            }
        }
    }

    function handleSave() {
        props.save({ name: companyName, domain: companyDomain, logo: companyLogo })
    }
    function handleCancel() {
        props.cancel()
    }

    useEffect(() => {
        const isCompanyNameValid = !!companyName;
        const isCompanyDomainValid = !!companyDomain && !companyDomain.startsWith('http') && !companyDomain.startsWith('www');
        const isCompanyLogoValid = !!companyLogo;
        setValid(isCompanyNameValid && isCompanyDomainValid && isCompanyLogoValid)
    }, [companyName, companyDomain, companyLogo]);

    return (
        <Modal show={true} onHide={() => handleCancel()} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Add Company</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={valid}>
                    <Form.Group className="mb-3" controlId="company.name">
                        <Form.Label>Company Name</Form.Label>
                        <Form.Control required type="text" value={companyName}
                            onChange={e => onCompanyNameChange(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="company.domain">
                        <Form.Label>Company Domain</Form.Label>
                        <Form.Control required type="text" value={companyDomain}
                            onChange={e => onCompanyDomainChange(e.target.value)}
                            isInvalid={companyDomain.startsWith('http') || companyDomain.startsWith('www')}
                        />
                        <Form.Control.Feedback type="invalid">
                            It looks like you have an invalid domain.
                        </Form.Control.Feedback>
                        <Form.Text className="text-muted">
                            <div><span style={{ color: "darkgreen" }}>Correct</span>: example.com</div>
                            <div><span style={{ color: "darkred" }}>Incorrect</span>: https://www.example.com</div>
                            <div>Domain name only. Do not include https:// or www portion of the website URL.</div>
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="company.logo">
                        <Form.Label>Logo</Form.Label>
                        <Form.Control type="file" ref={filePickerRef} accept="image/jpeg,image/png,.jpg,.jpeg,.png"
                            onChange={e => onCompanyLogoChange(e.target.value)}
                        />
                        <Form.Text className="text-muted">
                            <div>Recommended size: 400x200px. Acceptable formats: .png,.jpeg. Max size: 500Kb.</div>
                        </Form.Text>
                    </Form.Group>
                </Form>
                <Row className="justify-content-md-center">
                    <Col md="6" className="text-center">
                        {companyLogo && !logoTooLarge && <Image style={{ maxHeight: "128px" }} fluid src={companyLogo} />}
                        {logoTooLarge && <span style={{ color: "darkred" }}>Logo File Size Too Large (Max Size: 500kb)</span>}
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => handleCancel()}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={() => handleSave()} disabled={!valid || logoTooLarge}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    )
}